import React from "react";
import socketIOClient from "socket.io-client";
import TextField from '@material-ui/core/TextField';
import {  getMyProfile,getChatUsers,CHAT_URL,TOKEN_PREFIX} from "../../crud/auth.crud";
import {  format } from 'date-fns'
import Autocomplete from '@material-ui/lab/Autocomplete';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

import { Tooltip } from "@material-ui/core";  

import RefreshIcon from '@material-ui/icons/Refresh';

//import { messaging } from "../../../init-fcm";
                  
export default class Chat extends React.Component {

	state = {
		chatHistory:[],
		availableUsers:[],
		input:'',
		chatUsers:[],
		tags:'',
		toUsers:[],
		commPreference: 'both',
	}
constructor(props) {

	super(props);
	//const { endpoint } = this.state;
    //const socket = socketIOClient.connect('http://18.156.28.241:5000')


     let showUserList = true;

	  let pentity = {};
	  if (this.props.location!=null && this.props.location.data!=null) 
	  {
	    pentity = this.props.location.data;
	    showUserList = true;
	  }
	  else if(props.pentity!=null)
	  {
	  	console.log("props viewatient::::",props.pentity);
	     pentity = props.pentity;
	     showUserList = false;
	  }
	  
  
    
    const socket = socketIOClient.connect("https://mpe.practicemetrix.com:5000")
    super();
    this.state = {
      response: false,
      endpoint: "https://mpe.practicemetrix.com:5000",
      msg:{},
      socket:socket,
      chatHistory:[],
      input:'',
      tags:'',
      pentity:pentity,
      showUserList: showUserList,
	  toUsers: [],
	  commPreference: 'both',
    };
     this.updateChatHistory = this.updateChatHistory.bind(this);

     this.onCallBackJoin = this.onCallBackJoin.bind(this);
     this.onAvailableUsers = this.onAvailableUsers.bind(this);
     this.onCallBackRegister = this.onCallBackRegister.bind(this);
     this.onMessageReceived =  this.onMessageReceived.bind(this);
     this.onMessageReceived1 =  this.onMessageReceived1.bind(this);
     this.onInput = this.onInput.bind(this);
  }


  handlePrefChange = (event)=>
  {
	  console.log(event.target.value);
	  this.setState({commPreference:event.target.value});
  }
  sendMessage=()=>
  {
  	
  	//const { endpoint } = this.state;
  	//const { msg } = this.state;

  	//console.log("message:::::",this.state.msg);
    //const socket = socketIOClient(endpoint);
    //socket.emit("patientroom", "test"+new Date());
    let msgs = '';
    if(this.state.tags!=null && this.state.tags!='')
    {
    	msgs = this.state.tags + ' ' + this.state.input;
    }
    else
    {
    	msgs = this.state.input;
    }
    this.state.socket.emit('message', {chatroomName:this.state.pentity.pEntityId, message: msgs,toUsers: this.state.toUsers,commPreference:this.state.commPreference,token:localStorage.getItem(TOKEN_PREFIX+'_access_token')}, this.onMessageReceived1);
    this.setState({input:null,tags:null});
  }
  componentDidMount() {

/*
  	messaging.requestPermission()
    .then(async function() {
const token = await messaging.getToken();
	console.log("firebase::::",token);
    })
    .catch(function(err) {
      console.log("Unable to get permission to notify.", err);
    });
  navigator.serviceWorker.addEventListener("message", (message) => console.log(message));
*/

  	getMyProfile().then(response => response.data)
    .then((data) => {
      this.setState({ user: data })
      //console.log(data[0].userId)

    	if(this.state.socket!=null)
		{

			//console.log("pEntityId",this.props.location.data);
			this.state.socket.on('message', this.onMessageReceived);
			this.state.socket.emit('availableUsers', null, this.onAvailableUsers);
			this.state.socket.emit('register', data[0].userId,localStorage.getItem(TOKEN_PREFIX+'_access_token'), this.onCallBackRegister);
			 
		}
     })

    getChatUsers(this.state.pentity.pEntityId).then(response => response.data)
    .then((data) => {
		console.log("chatusers:::::",data);
		let chatusers = [];
		data.filter(x=>x.isDeleted===false && x.isActive===true).map((y)=>{
			chatusers.push(y);
		})
      	this.setState({ chatUsers: chatusers });

    	//console.log("getChatUsers",data);
     })
   
    /*
    socket.on("FromAPI", data => this.setState({ response: data }));
    console.log("ressssssss::::",this.state.response);

    setInterval(() => {
	  //console.log('Interval triggered');
	  socket.on("patientroom", data => this.setState({ response: data }));
	   console.log("ressssssssfromw::::",this.state.response);
	}, 100);
	*/
	//const socket = socketIOClient(endpoint);
	/*setInterval(() => {
	  //console.log('Interval triggered');
	  this.state.socket.on('message', this.onMessageReceived);
	   
	}, 100);*/
  }

  updateChatHistory(entry) {
    this.setState({ chatHistory: this.state.chatHistory.concat(entry) })
  }

  componentWillUnmount()
  {
  	//this.socket.emit('leave', this.props.location.data.pEntityId, this.onMessageReceived);
  	this.state.socket.off('message');
  	this.state.socket.emit('disconnect');
  }

  onInput(e) {
    this.setState({
      input: e.target.value
    })
  }

  onInputChange=(event,value)=>{
//console.log(value)


}

 onSelectTag=(e, value)=> {

let toUsers = [];
let tguser='';
 	if(value!=null)
 	{
 		value.map((user)=>(
 			tguser = tguser + '@' + user.firstName + ' ' + user.lastName +' ' , toUsers.push(user.userId)
 			))
 		this.setState({
      tags: tguser, toUsers: toUsers
    	})
		console.log("toooo",toUsers);
 	}
	
//console.log("tags",value);
}

refresh=()=>
{
	getChatUsers(this.state.pentity.pEntityId).then(response => response.data)
    .then((data) => {
		console.log("chatusers:::::",data);
		let chatusers = [];
		data.filter(x=>x.isDeleted===false && x.isActive===true).map((y)=>{
			chatusers.push(y);
		})
      	this.setState({ chatUsers: chatusers });

    	//console.log("getChatUsers",data);
     })
}

  onAvailableUsers(err,entry)
  {
  	//console.log('availableUsers',entry);
  	this.setState({ availableUsers: entry })
  }
  onMessageReceived(entry) {
    //console.log('onMessageReceived:', entry);
    //this.updateChatHistory(entry)
    let history = this.state.chatHistory;
    history.push(entry);
    this.setState({ chatHistory: history });
  }

  onMessageReceived1(entry) {
    //console.log('onMessageReceived1:', entry);
    //this.updateChatHistory(entry)
    //this.setState({ chatHistory: this.state.chatHistory.concat(entry) });
    this.setState({input:'',tags:''});
  }

   onCallBackJoin(err,entry) {
    //console.log('Join:', entry);
    // console.log('Join:', err);
    //this.updateChatHistory(entry);
    let en=[];
    //if(this.state.chatHistory!=null)
    //{
    //en = this.state.chatHistory;
	//}
    en.push(entry);
  
    this.setState({ chatHistory: entry })

    //console.log(this.state.chatHistory, "chatHistory");
	
    //this.updateChatHistory(entry)
  }
  onCallBackRegister(entry) {
    console.log('register:', entry)
    //this.updateChatHistory(entry)
   this.state.socket.emit('join', this.state.pentity.pEntityId,localStorage.getItem(TOKEN_PREFIX+'_access_token'), this.onCallBackJoin);
	
  }

  

	render()
	{
		const userslist = this.state.chatUsers;
		
		return (
			<>

				<div className="kt-grid kt-grid--desktop kt-grid--ver kt-grid--ver-desktop kt-app">
								
								<button className="kt-app__aside-close" id="kt_chat_aside_close">
									<i className="la la-close"></i>
								</button>

								{this.state.showUserList &&
								<div className="kt-grid__item kt-app__toggle kt-app__aside kt-app__aside--lg kt-app__aside--fit" id="kt_chat_aside">

									
									<div className="kt-portlet kt-portlet--last">
										<div className="kt-portlet__body">
											<div className="kt-chat__label">
												<a className="kt-chat__title">Users List</a>
												
											
											</div>
											<div className="kt-widget kt-widget--users kt-mt-20">
												<div className="kt-scroll kt-scroll--pull" style={{'max-width':'350px','overflow':'auto'}}>
													<div className="kt-widget__items">

														{this.state.chatUsers!=null && this.state.chatUsers.map((user)=>

														<div className="kt-widget__item">
															<span className="kt-media kt-media--circle">
																<img src="media/users/default.jpg" alt="image"/>
															</span>
															<div className="kt-widget__info">
																<div className="kt-widget__section">
																	<a  className="kt-widget__username">{user.firstName + " " + user.lastName}</a>
																	
																</div>
																<span className="kt-widget__desc">
																	{user.role + ' ('+user.account+')'}
																</span>
															</div>
															{/*<div className="kt-widget__action">
																<span className="kt-widget__date"></span>
																<span className="kt-badge kt-badge--success kt-font-bold">7</span>
															</div>*/}
														</div>

														)}
														
														
													</div>
												</div>
											</div>
										</div>
									</div>

									
								</div>
							    }

								
								<div className="kt-grid__item kt-grid__item--fluid kt-app__content" id="kt_chat_content">
									<div className="kt-chat">
										<div className="kt-portlet kt-portlet--head-lg- kt-portlet--last">
											<div className="kt-portlet__head">
												<div className="kt-chat__head ">
													<div className="kt-chat__left">

														
										<div className="kt-chat__label">
											<a  className="kt-chat__title">{this.state.pentity.firstName + ' '+ this.state.pentity.lastName}
											
											
											</a>
											<span className="kt-chat__status">
												<span className="kt-badge kt-badge--dot kt-badge--success"></span> Active
											</span>
										
										</div>
														

														
													</div>
													<div className="kt-portlet__head-toolbar">
													<Tooltip
	          										title="Refresh Users" 

	          									><RefreshIcon style={{ color: '#5867dd',fontSize: 25}} onClick={()=>this.refresh()} /></Tooltip>
													</div>
													<div className="kt-chat__center">
														<div className="kt-chat__label kt-hidden">
															<a className="kt-chat__title">Jason Muller</a>
															<span className="kt-chat__status">
																<span className="kt-badge kt-badge--dot kt-badge--success"></span> Active
															</span>
														</div>
														
													</div>
													
												</div>
											</div>
											<div className="kt-portlet__body">
												<div className="kt-scroll kt-scroll--pull" data-mobile-height="300" style={{'min-height':'280px','max-height':'350px','overflow':'auto'}}>
													<div className="kt-chat__messages">

														{  this.state.chatHistory!=null && this.state.chatHistory.map((chat)=>

														(chat.message!=null &&
														<div className="kt-chat__message">
															<div className="kt-chat__user">
																<a className="kt-chat__username">{chat.user.name + " " + chat.user.lastName}</a>
																<span className="kt-chat__datetime">{format(new Date(chat.dObj), 'MM/dd/yyyy hh:mm:ss')} </span>
															</div>
															<div className="kt-chat__text kt-bg-light-success" style={{fontSize:'12px'}}>
																{chat.message}
															</div>
														</div>
														)

														)}
													
														
													</div>
												</div>
											</div>
											<div className="kt-portlet__foot">
												<div className="kt-chat__input">
													<div className="kt-chat__editor">
													{userslist!=null && 
														   <Autocomplete
													        multiple
													        id="tags-standard"
													        options={userslist}
													        defaultValue={this.state.tag}
													        onChange={this.onSelectTag}
													        getOptionLabel={(option) => '@'+option.firstName+ ' '+option.lastName}
													        renderInput={(params) => (
													                  <TextField
													                  {...params}
          
									                          margin="normal"
									                          label="To"
									                          className="kt-width-full"
									                          name="to"
									                          multiLine
												              rows={4}
												              rowsMax={4}
												              value={this.state.tag}
												            />

        )}
      />
  }
														<TextField
									                          margin="normal"
									                          label="Message"
									                          className="kt-width-full"
									                          name="message"
									                          multiLine
												              rows={4}
												              rowsMax={4}
												              onChange={this.onInput}
												              value={this.state.input}
												              onKeyPress={e => (e.key === 'Enter' ? this.sendMessage() : null)}
									                         
									                        />
														
													</div>
													<div className="kt-chat__toolbar">
														{/*<div className="kt_chat__tools">
															<a href="#"><i className="flaticon2-link"></i></a>
															<a href="#"><i className="flaticon2-photograph"></i></a>
															<a href="#"><i className="flaticon2-photo-camera"></i></a>
														</div>*/}
														<div className="kt_chat__actions">
															<div className="row">
																<div className="col">
																	<button type="button" onClick={this.sendMessage} className="btn btn-brand btn-md btn-upper btn-bold kt-chat__reply">reply</button>
																</div>
															</div>
															<div className="row">
																<div className="col">
																	<FormControl component="fieldset">
																		<FormLabel component="legend">Communication Preference</FormLabel>
																		<RadioGroup aria-label="commPreference" name="commPreference" value={this.state.commPreference} onChange={this.handlePrefChange} row  >
																			<FormControlLabel value="email" control={<Radio />} label="Email" />
																			<FormControlLabel value="text" control={<Radio />} label="Text" />
																			<FormControlLabel value="both" control={<Radio />} label="Both" />
																			
																		</RadioGroup>
																	</FormControl>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							

							</div>
							</>
			)
	}
    
};